var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2946",
    x1: 44,
    x2: 64,
    y1: 4329,
    y2: 4329,
    gradientTransform: "translate(56,160)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-100 -4479)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "focus_center-[#839]",
    d: "m104 4492h-2v5h5v-2h-3zm12 3h-3v2h5v-5h-2zm-12-12h3v-2h-5v5h2zm12 3h2v-5h-5v2h3zm4 2v2h-9v9h-2v-9h-9v-2h9v-9h2v9z",
    style: {
      fill: "url(#linearGradient2946)"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3.5169,
    style: {
      strokeWidth: 1.333
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.2d0899e2b6cdf3ded6e4776d4e079890.svg";
export { ForwardRef as ReactComponent };